'use client'

import { Checkbox } from 'antd'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputOptin: SBDynamicFormInput = ({ item, ...rest }) => {
  return (
    <Checkbox {...rest}>
      <div
        className="plethore-custom-html-optin"
        onClick={(e) => {
          // Laisser les liens du libellé cliquables sans cocher la case
          if ((e.target as HTMLElement).closest('a')) e.stopPropagation()
        }}
        dangerouslySetInnerHTML={{ __html: item.title }}
      ></div>
    </Checkbox>
  )
}

export { SBDynamicFormInputOptin }
